import { render, staticRenderFns } from "./serviceCreate.vue?vue&type=template&id=1bad6d46&scoped=true"
import script from "./serviceCreate.vue?vue&type=script&lang=js"
export * from "./serviceCreate.vue?vue&type=script&lang=js"
import style0 from "./serviceCreate.vue?vue&type=style&index=0&id=1bad6d46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad6d46",
  null
  
)

export default component.exports